export const ACTION_CODE = 'TRAINING_ATTENDANCES' + '_ACTION';
